
import { TAO_KOE } from './../libs';

function scrollHash() {
	const elem = document.querySelector( location.hash.toLowerCase() );
	const serviceRow = document.querySelector( '.mdl_servicerow' );
	const headerBar = document.querySelector( '.mdl_header__bar' );

	let offset = 0;

	if ( serviceRow ) {
		offset += serviceRow.offsetHeight;
	}
	if ( headerBar ) {
		offset += headerBar.offsetHeight;
	}

	if ( elem ) {
		const rect = elem.getBoundingClientRect();
		const scrollY = ( rect.top + window.pageYOffset ) - offset;
		document.scrollingElement.scrollTo( {
			top: scrollY,
			behavior: 'smooth',
		} );
	}
}

TAO_KOE.ready( 'scrolling.js', function() {
	addEventListener( 'hashchange', scrollHash );
} );
